import { render, staticRenderFns } from "./Page2.vue?vue&type=template&id=53620974&scoped=true"
var script = {}
import style0 from "./Page2.vue?vue&type=style&index=0&id=53620974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53620974",
  null
  
)

export default component.exports